import { Camera } from './camera.model';

export class NOC2 extends Camera {
    hasSensitivityConfig = true;
    hasVisionRecognitionConfig = true;

    minimumRebootFirmware = 0;
    minimumUnlockFirmware = 0;
}
